"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupStyle = void 0;
var TabStyles_1 = require("./TabStyles");
exports.PopupStyle = {
    background: 'white',
    border: "1px solid " + TabStyles_1.TabStyles.Colors.L6,
    boxShadow: TabStyles_1.TabStyles.Shadow.Elevated,
    boxSizing: 'border-box',
    lineHeight: 'normal',
};
//# sourceMappingURL=Standard.js.map